import { ICalendarEventsDTO, ICalendarEventsParams } from 'src/api/dtos';
import ESSRepository from 'src/api/repositories/ess/ess.repository';
import api from 'src/api/rtk/rtk-api';

export default class CalendarRepository extends ESSRepository {
  private static readonly baseRoute = '/calendar';
  private static readonly apiURL = CalendarRepository.setBaseUrl(this.baseURL, this.baseRoute);

  public static endpoints = api.injectEndpoints({
    overrideExisting: true,
    endpoints: (build) => ({
      getEvents: build.query<ICalendarEventsDTO, ICalendarEventsParams>({
        query: (params) => {
          return { url: `${this.apiURL}/events`, method: 'get', params };
        },
        providesTags: [{ type: 'Calendar', id: 'LIST' }],
      }),
    }),
  });
}
